module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 600
// module chunks = 0